import { useEffect } from "react"

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches

// Scrolls to an element by id and moves focus there for keyboard and
// screen-reader users. Returns false when the element is not on this page.
export const scrollToId = id => {
  if (typeof document === "undefined") return false
  const target = document.getElementById(id)
  if (!target) return false
  target.scrollIntoView({
    behavior: prefersReducedMotion() ? "auto" : "smooth",
    block: "start",
  })
  if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1")
  target.focus({ preventScroll: true })
  return true
}

// Click handler for in-page anchor links. Gatsby's scroll restoration treats
// native hash navigation as a return to the "initial" location and restores
// the previously saved scroll position, so after the first click anchors stop
// working. Scrolling ourselves and updating the hash with replaceState keeps
// the router out of it. Links to another page fall through to the browser.
export const scrollToAnchor = event => {
  const element = event.currentTarget
  const href = element && element.getAttribute("href")
  if (!href || href.indexOf("#") === -1) return
  const [path, id] = href.split("#")
  if (!id) return
  const here = window.location.pathname.replace(/\/$/, "")
  if (path && path.replace(/\/$/, "") !== here) return
  if (scrollToId(decodeURIComponent(id))) {
    event.preventDefault()
    window.history.replaceState(window.history.state, "", `#${id}`)
  }
}

// On pages opened with a hash (e.g. /#services from a subpage) Gatsby may
// restore an old scroll position instead of jumping to the target.
export const useHashScrollOnLoad = () => {
  useEffect(() => {
    const hash = window.location.hash.slice(1)
    if (!hash) return undefined
    const timer = window.setTimeout(
      () => scrollToId(decodeURIComponent(hash)),
      60
    )
    return () => window.clearTimeout(timer)
  }, [])
}
